module.exports = __webpack_public_path__ + "public/images/icon-arrow-up.27c5b2d28d322f5b4162fad7ef30419b.svg";